import { MobileAppRoutes } from "@/components-mobile/app-routes";
import { EditorPopups as MobileEditorPopups } from "@/components-mobile/popup/popups";
import { AppRoutes } from "@/components/app-routes";
import { InviteCodeContextProvider } from "@/components/auth/invite-code";
import { NetworkStatusWrapper } from "@/components/network-status-error";
import { ToastProvider } from "@/components/popup/message-toast";
import { EditorPopups as DesktopEditorPopups } from "@/components/popup/popups";

import { editorContextStore, initEditorContextVanillaStore } from "@/contexts/editor-context";
import { ProjectInitSceneContextProvider } from "@/contexts/project-init-scene-context";
import { useAuthUpdateEffect } from "@/hooks/use-auth-update";
import { useFeatureFlagsEffect } from "@/hooks/use-featureFlags";
import { useCheckMobileEffect } from "@/hooks/use-mobile-context";
import { usePricingConfigUpdateEffect } from "@/hooks/use-pricing-config-update";
import { useTeamsUpdateEffect } from "@/hooks/use-teams-update";
import { useUserStripeSubscriptionUpdateEffect } from "@/hooks/use-user-stripe-subscription-update";
import { initObjects } from "@/objects";
import * as Tooltip from "@radix-ui/react-tooltip";
import React from "react";

initObjects();
initEditorContextVanillaStore();

function Routes() {
  const isMobile = editorContextStore((state) => state.isMobile);

  return isMobile ? <MobileAppRoutes /> : <AppRoutes />;
}

function Popups() {
  const isMobile = editorContextStore((state) => state.isMobile);

  return isMobile ? <MobileEditorPopups /> : <DesktopEditorPopups />;
}

function App() {
  React.useEffect(() => {
    const handleWheelEvent = (e: WheelEvent) => {
      if (e.ctrlKey) {
        e.preventDefault(); //prevent zoom
      }
      // prevent horizontal scrolling
      if (e.deltaX !== 0) {
        e.preventDefault();
      }
    };
    const handleKeyEvent = (e: KeyboardEvent) => {
      if (!e.ctrlKey) {
        return;
      }
      if (e.code === "Minus" || e.code === "Equal") {
        e.preventDefault();
      }
    };

    document.body.addEventListener("wheel", handleWheelEvent, { passive: false });
    window.addEventListener("keydown", handleKeyEvent);
    return () => {
      document.body.removeEventListener("wheel", handleWheelEvent);
      window.removeEventListener("keydown", handleKeyEvent);
    };
  }, []);

  useAuthUpdateEffect();

  useTeamsUpdateEffect();

  useCheckMobileEffect();

  useFeatureFlagsEffect();

  useUserStripeSubscriptionUpdateEffect();

  usePricingConfigUpdateEffect();

  return (
    <NetworkStatusWrapper>
      <Tooltip.Provider>
        <ToastProvider>
          <InviteCodeContextProvider>
            <ProjectInitSceneContextProvider>
              <Routes />
              <Popups />
            </ProjectInitSceneContextProvider>
          </InviteCodeContextProvider>
        </ToastProvider>
      </Tooltip.Provider>
    </NetworkStatusWrapper>
  );
}

export default App;
